import { render, staticRenderFns } from "./VCross.vue?vue&type=template&id=fbc44aa8&"
import script from "./VCross.vue?vue&type=script&lang=js&"
export * from "./VCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports